<template>
  <div class="sing-in">
    <b-form @submit="singIn" class="sing-in-form text-center">
      <h3 class="title">Sign In</h3>
      <b-form-input type="email" v-model="email" placeholder="Your email" required />
      <b-form-input
        type="password"
        v-model="password"
        placeholder="Your password"
        minlength="8"
        required
      />

      <div class="d-flex">
        <div>
          <router-link
            class="link"
            :to="{name: 'password-reset'}">
            Forgot Your Password?
          </router-link>
        </div>
        <div class="ml-auto">
          <b-button
            class="button"
            type="submit"
            variant="primary"
          >
            Sign In
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { reject } from 'q'
export default {
  data () {
    return {
      email: '',
      password: '',
      token: ''
    }
  },
  methods: {
    singIn (e) {
      e.preventDefault()
      this.axios
        .post('/api/auth/login', {
          email: this.email,
          password: this.password
        })
        .then(response => {
          const user = response.data.user.original
          this.$store.dispatch('setAccessToken', response.data.access_token)
          localStorage.setItem('refresh_token', response.data.refresh_token)
          this.$store.dispatch('setUser', user)
          this.$store.dispatch('setUserRoles', user.roles)
          this.axios
            .get(`/api/permissions/${user.id}`)
            .then(({ data }) => {
              this.$store.dispatch('setPermission', data)
              this.$store.dispatch('setUserName', user.name)
              this.$store.dispatch('setUserId', user.id)
              this.email = ''
              this.password = ''
              this.$store.dispatch('setActive', false)
            })
            .catch(error => {
              reject(error)
            }).finally(() => {
              this.$router.push({ name: 'home' })
            })
        })
        .catch(error => {
          console.log(error.response)
          this.$snotify.error(
            error.response.data.error,
            'Error',
            this.$store.state.snotify
          )
        })
    }
  }
}
</script>

<style scoped>
.sing-in{
  display: flex;
  justify-content: center;
}
.sing-in-form {
  width: 320px;
}

.sing-in-form h3 {
  margin-bottom: 20px;
}

.sing-in-form input {
  margin-bottom: 20px;
}
</style>
